import { Callout, ShopifyCallout, ProductMetafields, ShopSettings } from "~/types"

type PropsCallouts = 
{
    product: ProductMetafields;
    settings: ShopSettings;
}
export default function ShopifyCallouts ( {product, settings} : PropsCallouts)
{
    const callouts : ShopifyCallout = JSON.parse(product.callouts?.value ?? "{}");
    const calloutDefinitions : Callout[] = settings?.calloutDefinitions != null ?  settings?.calloutDefinitions : [];

    return (
        <div className="card-stock">
            {calloutDefinitions.map(callout => 
                (<>
                    {callouts[callout.callout.toLocaleLowerCase()] && <Item callout={callout}></Item>}
                </>)
            )}
        </div>
    )
}

type PropsItem =
{ 
    callout:Callout
}

const Item = ( {callout} : PropsItem) => 
{
    const style : React.CSSProperties = 
    {
        backgroundColor : callout.backgroundColor,
        color:callout.textColor,
        border: callout.borderColor !== "" ? `1px solid ${callout.borderColor}` : "",
    }
    return (
        <p style={style} className={`badge ${callout.callout}`}>
            {callout.label}
        </p>
    )
}